import {confirmComponent} from "./confirm.component";

export const confirmModule = angular
	.module("confirm", [])
	.component("confirm", confirmComponent);


// WEBPACK FOOTER //
// ./sources/utility/confirm/confirm.js